import { styled } from "@mui/material";

export const LayoutBasicPageMain = styled("main")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  padding: theme.spacing(6),
}));
